// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tz-spinner__spin-circle{animation:spin 1.5s linear infinite;overflow:visible}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.tz-spinner__loader-container{max-height:50px;max-width:50px;position:relative}.tz-spinner__loader{transform:rotate(-90deg)}.tz-spinner__image{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
